export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.18576555.ttf";